export const japanese = {
  translation: {
    // ================================= titles =================================
    titles: {
      popular_add_ons: 'よく一緒に注文される商品',
      top: 'トップ',
      hello: 'こんにちは',
      in_your_cart: 'カートの内容',
      search_result: '検索結果',
      no_items_found: '0 件の商品が見つかりました',
      search_empty: '表示するデータがありません',
      call_staff: '呼び出しリクエストを受け取りました',
      sub_total: '小計',
      total: '合計',
      order_details: 'ご注文内容',
      order_history: '注文履歴',
      popup_pay: 'お会計しますか？',
      payment_success: 'お会計リクエストを受け取りました',
      order_empty: 'ご注文はありません',
      pending: '保留中',
      served: '確認済み',
      confirmed: '確認済み',
      finish_cooking: '調理が完了しました',
      cancelled: 'キャンセルされました',
      ready_to_order: 'オーダーしますか？',
      order_success: 'ご注文を受け付けました',
      maxQuantityPerOrder: '1オーダーあたりの最大注文可能数',
      topping_type_quantity: '{{min}}以上 - {{max}}以下',
      menu_excludes_vat: 'この価格はVATを含みません。',
      menu_excludes_vat_ja: 'この価格は消費税を含みません。',
      rescanQR: 'もう一度、QRコードを読み込んでください。',
      choose_language_to_start: '使用言語を選択してください',
      extraFee: '追加料金',
      discountAmount: '値引き',
      customizedService: '下記の項目を選択してください',
      selectOption: '',
      call_staff_reasons: 'スタッフを呼ぶ',
      choose_payment_method: 'お支払い方法をお選びください',
      payment_successfully: '支払い完了',
      payment_failed: '支払いに失敗しました',
      how_was_your_experience: 'お店のご評価をお教えください',
      your_details: 'お客様情報をご入力ください',
      how_many_people: '何名様のご来店ですか？',
      please_select_number_of_people: '※幼児を含む人数を選択してください',
      choose_number_of_people: '今日のテーブルの人数を選択してください:',
      buffet: 'ブフェット',
      order_placed: '注文を受付けました!',
      order_code: '注文番号',
      review_order: 'お店のレビューはこちらから',
      popular: '人気のメニュー',
      hope_you_enjoyed: 'ご満足いただけましたか？',
      review_success: 'ありがとうございました !',
      popup_food_error_order:
        '<span style="font-weight:{{fontWeight}}">{{nameFood}}</span> は品切れ中です。',
      popup_topping_error_order:
        'The topping <span style="font-weight:{{fontWeight}}">{{nameTopping}}</span> out of stock!',
      input_a_name: '名前を入力する',
      input_a_phone: '電話番号を入力してください',
      why_we_need_it: '名前が必要な理由',
      discount: '割引',
      // tablet
      search: '検索',
      call_staff_tablet: 'スタッフを呼ぶ',
      bill: '請求書',
      pay: '支払い',
      table_number: 'テーブル番号:',
      ask_for_bill: 'お会計する',
      ask_for_bill_decription: 'お会計する“をタップすると、スタッフがご請求をお持ちいたします',
      not_yet: 'あとで',
      quantity: '数量',
      item_table: '項目',
      status_table: 'ステータス',
      price_table: '価格',
      other: 'その他',
    },
    // ================================= descriptions =================================
    descriptions: {
      reached_end: '終了しました。',
      cart_empty: 'カートの中身は空です',
      hint_cart_empty: 'クリックしてメニューを見る',
      search_empty: '誤字がないかや違うキーワードでもう一度検索してください',
      call_staff: 'まもなくお席にスタッフがお伺いします。しばらくお待ちください。',
      popup_pay: '「お会計リクエスト」をタップすると、スタッフがテーブルに明細を持ってきます。',
      payment_success: '少々お待ち下さい',
      restaurant_on_capichi:
        '当店の料理は<span style="color:{{colorText}}">Capichi</span>アプリからデリバリー注文いただくことが可能です。',
      order_empty: 'お好きな料理を選んで、注文を追加してください。',
      orderNotFound: '注文が見つかりません！',
      order_success: '現在準備しています。ご提供まで少々お待ち下さい。',
      rescanQR:
        '申し訳ありません。前回の決済が完了しましたので、もう一度QRコードをスキャンする必要があります。',
      // new
      order_food_and_drink: 'いつでも料理やドリンクをスマホから注文',
      seek_for_help: '困った時は店員さんを呼び出し機能ですぐにサポート',
      ask_to_pay: 'お食事が終わればスマホからお会計リクエストを送信',
      or_ask_directly: 'or リクエストを選ぶ',
      haveVAT: '{{vatRate}}%の付加価値税は含まれていません',
      haveServiceFee: '{{serviceRate}}%のサービス料',
      popup_payment_success:
        'お支払いが完了しました。ご利用ありがとうございます！素敵な料理でお食事をお楽しみください。',
      popup_payment_failed:
        'エラーが発生した為、決済に失敗しました。再度お試しいただくか、別のお支払い方法をご利用ください。',
      tap_to_save_screen: '注文番号をお店のスタッフに見せてください',
      checkouted_order: `本日は当店をご利用いただきまして誠にありがとうございます。サービス改善のため、お客様のご意見・ご感想をお聞かせください。`,
      review_success: '頂いたレビューをサービス改善に役立たてます!',
      input_a_name:
        '注文を正しく管理するため、注文を識別する簡単な名前*をご入力いただく必要があります。',
      input_a_phone:
        'ご注文が完了した後にご注文に関するメッセージや連絡をするために、お客様の電話番号が必要です。',
      min_left: '{{min_left}}分間は対象メニューとドリンクが食べ放題・飲み放題です。',
    },

    // ================================= actions =================================
    actions: {
      call_staff: 'スタッフを呼ぶ',
      pay: 'お会計',
      back_to_top: 'ページトップへ戻る',
      order: 'ご注文',
      go_back: '戻る',
      see_menu: 'メニューを見る',
      order_now: '今すぐ注文する',
      clear_all: 'すべて消去',
      search_again: '再度検索する',
      retry: 'リトライ',
      back_to_menu: '注文画面に戻る',
      ask_for_bill: 'お会計リクエスト',
      not_yet: 'キャンセル',
      discover: 'アプリをダウンロード',
      delete_dish: '削除する',
      noteFood: '特別なリクエストなどを追加する',
      addToCart: 'カゴに追加',
      addNote: 'メモを追加',
      confirmOrder: '確認',
      // new
      start_ordering: 'オーダーを開始する',
      pay_online: 'オンライン決済',
      send: '送信する',
      try_again: 'もう一度試す',
      call_staff_for_help: 'サポートへ連絡する',
      skip: 'スキップする',
      next: '次へ進む',
      done: '完了',
      confirm: '確認',
      order_from_here: '今すぐオーダーする',
      tap_to_save_screen: '注文番号の画像を保存する',
      see_a_menu: 'メニューを確認',
      update: '更新',
      cancel: 'キャンセル',
      add: '追加',
      ok: 'OK',
      see_the_time: '時間を見る',
    },

    // ================================= errors =================================
    errors: {
      server_error: 'サーバーに接続できません',
      errorOutOfStock:
        'すみません、これらの商品は売り切れてしまいました。他の商品を選んでいただけますか？',
      errorQuantityPerOrder:
        '商品を選択できる数の上限に達していますので、これ以上数を増やすことができません.',
      errorQuantityExceeded:
        'すみません、これらの商品の在庫がお客様の希望注文数に足りなくなりました。注文数を修正していただけますか？',
      somethingWrong: '何かエラーがあります。再度お試しください。',
      errorFoodHasChanged: 'すいません。お店は商品の情報を更新しましたので再度ご注文をお願いします',
      warningMin: 'このトッピングは{{min}} 以上の選択が必須です',
      warningMax: 'このトッピングは最大{{max}} までしか選択できません',
      notFoundFoodItem:
        'このレストランは現在提供を中止しています。時間を空けて、再度ご確認ください。',
      errorNotOpenTable:
        'スタッフを呼んでください。【エラー】POSシステムのオーダーが有効になっていません。',
      max_comment_review: '最大{{max}}文字まで',
      payment_method_changed: '決済エラーが発生しました',
      payment_method_changed_desc: 'お支払い方法を変更してもう一度お試しください',
      max_characters: '{{max}}文字以下でご記入ください',
      required_floor: 'お泊りの階をご入力ください',
      required_room: 'お泊りの部屋番号をご入力ください',
      required_full_name: 'ご氏名をご記入ください',
      errorOutOfStockNEC: '在庫なし',
      rating_already_existed: 'こちらのオーダーはすでに評価済みです。',
      voucher_not_suitable: 'クーポンコードが適切ではありません。もう一度お試しください。',
      error: 'エラー',
      voucher_not_found: 'クーポンコードが存在しません。別のコードをお試しください。',
      voucher_outside_time_period:
        'クーポンコードが無効、または有効期限が切れています。別のコードをお試しください。',
      voucher_just_apply_for_restaurants:
        'クーポンコードは以下のレストランにのみ適用されます： {{restaurants}}',
      voucher_min_order_value: 'クーポンコードは {{min_order_value}} からの注文に適用されます。',
      voucher_has_been_used: 'クーポンコードは使用済みです。',
      voucher_out_of_quantity: 'このクーポンコードは使用できません。別のコードをお試しください。',
      min_max_phone_number: '{{min}}-{{max}}文字の間で電話番号を入力してください。',
    },

    // ================================= languages =================================
    languages: {},
    // ================================= label =================================
    label: {
      zezoYen: '0円',
      required: '必須',
      optional: '自由選択',
      my_cart: 'カート',
      items_found: '該当項目が見つかりました。',
      sold_out: '売切れ',
      items: '項目',
      powered_by: 'Powered by',
      vat: 'VAT',
      vat_ja: '消費税',
      service_fee: 'サービス料',
      your_order: 'ご注文',
      or: 'または',
      payment_methods: {
        international_card: 'クレジットカード',
        atm: 'ATMカード',
        qr_code: 'QRコードで送金',
        e_wallet: 'E-ウォレット',
      },
      review_or_comment: 'レビューやコメントをお寄せください',
      only_letters: 'アルファベットのみ可',
      buffet: '食べ放題',
      min_left: '残り<strong style="color:{{color}}">{{min_left}}</strong>分',
      all_you_can_drink: '飲み放題対象ドリンク',
    },
    // ================================= placeholder =================================
    placeholder: {
      input_search: '料理、メニュー、飲み物を検索する...',
      choose_your_floor: 'お泊りの階をお選びください',
      choose_your_room: '部屋番号をお選びください',
      your_full_name: 'ご氏名をご記入ください',
      no_results: '検索結果なし',
      your_name: 'お名前',
      enter_voucher_code: 'クーポンコードを入力',
      your_phone: '電話番号',
    },
    popup_start_buffet: {
      course_menu_has_started: '“Course menu” が開始しました',
      time_limit: ' 制限時間',
      time_value: '{{value}} 分',
      see_menu: '対象メニューを確認',
    },
    popup_add_friend_line: {
      line: 'LINE',
      description: 'LINEの公式アカウントで \n お得な情報を配信中！',
      add_friend_btn: 'LINE友達追加する',
      already_added: '友達追加済み/追加せず注文',
    },
  },
}
